import { render, staticRenderFns } from "./NavButton.vue?vue&type=template&id=53ff35e8&scoped=true&"
import script from "./NavButton.vue?vue&type=script&lang=js&"
export * from "./NavButton.vue?vue&type=script&lang=js&"
import style0 from "./NavButton.vue?vue&type=style&index=0&id=53ff35e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ff35e8",
  null
  
)

export default component.exports